import React from "react";
import { ConfirmationModal, FormColumn2Wide, RadioGroup, useLoading } from "best-common-react";
import { parseFileToDataString } from "best-common-react-3";
import styled from "styled-components";
import { useProspectProfile } from "../../../contexts/ProsepctProfileContext";
import ProfilePicturePreview from "./photo/ProfilePicturePreview";
import ProfilePictureUpload from "./photo/ProfilePictureUpload";
import { deleteProspectPhoto, uploadProspectPhoto } from "../../../api/AuthenticatedClient";
import { Paper } from "best-common-react";
import { useTranslation } from "react-i18next";
import { useDropdowns } from "../../../contexts/DropdownsContext";

const Container = styled.div``;

const PhotoSection: React.FC = () => {
  const { t } = useTranslation(["profile", "translation"]);
  const { profile, updateProfileField, updateMultipleProfileFields } = useProspectProfile();
  const { yesNoRadioValues, getYesNoRadioValues } = useDropdowns();
  const { setLoading } = useLoading();
  const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);

  const onHasPhotoChange = (value: boolean) => {
    if (!value && profile?.hasPhoto) {
      setShowConfirmDelete(true);
    } else {
      updateProfileField("hasPhoto", value);
    }
  };

  const deleteProfilePicture = async () => {
    try {
      setLoading(true);
      await deleteProspectPhoto();
      updateMultipleProfileFields({
        photoUrl: undefined,
        hasPhoto: false,
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const uploadProfilePicture = async (file: File) => {
    try {
      setLoading(true);
      const fileData: string = await parseFileToDataString(file);
      const request = {
        fileName: file.name,
        fileData,
      };
      const { photoUrl } = await uploadProspectPhoto(request);
      updateMultipleProfileFields({
        hasPhoto: true,
        photoUrl: photoUrl,
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ConfirmationModal
        show={showConfirmDelete}
        header={t("translation:areYouSure")}
        body={t("profile:confirmDeletePhotoMessage")}
        confirmButtonText={t("translation:confirm")}
        cancelButtonText={t("translation:cancel")}
        onConfirm={() => {
          deleteProfilePicture().then(() => setShowConfirmDelete(false));
        }}
        onCancel={() => setShowConfirmDelete(false)}
      />
      <Container>
        <Paper className="mb-3">{t("profile:photoSection")}</Paper>
        <div className="row pt-2">
          <FormColumn2Wide>
            <RadioGroup
              id="has-photo-radio"
              label={t("profile:hasPhotoQuestion")}
              name="hasProspectPhoto"
              className="pb-2"
              options={yesNoRadioValues.sort((a, b) => (a.value > b.value ? -1 : 1))}
              value={getYesNoRadioValues(profile?.hasPhoto)?.value}
              onChange={(value) => {
                onHasPhotoChange(value === 1);
              }}
            />
          </FormColumn2Wide>
        </div>

        {profile?.hasPhoto && (
          <div>
            {!!profile?.photoUrl ? (
              <ProfilePicturePreview url={profile.photoUrl} onDelete={deleteProfilePicture} />
            ) : (
              <ProfilePictureUpload onUpload={uploadProfilePicture} />
            )}
          </div>
        )}
      </Container>
    </>
  );
};

export default PhotoSection;
